import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@/hooks/use-toast';
import { publicFlowsService } from '../services/publicFlows.service';
import { orgKeys } from '../services/organization.keys';
import type { CreateOrgDto } from '../types/organization.types';

export function useCreateOrganization() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ name, organizationType }: CreateOrgDto) => {
      return publicFlowsService.createOrganizationWithOwner({ name, organizationType });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: orgKeys.userOrgs() });
      queryClient.invalidateQueries({ queryKey: orgKeys.current() });
      toast({
        title: 'Organization created',
        description: 'Your organization has been set up successfully.',
      });
    },
    onError: (error: any) => {
      console.error('Error creating organization:', error);
      toast({
        title: 'Failed to create organization',
        description: error?.message || 'Please try again.',
        variant: 'destructive',
      });
    },
  });
}
